import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import CompaniesView from './view/CompaniesView';
import CompaniesDetails from './details/CompaniesDetails';
import CompaniesDetailsHeaderAdditionalInfo from './details/CompaniesDetailsHeaderAdditionalInfo';

import buttons from './CompaniesButtons';
import events from './CompaniesEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('companies'),
	routes: [
		{
			path: 'companies/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'companies'),
			element: (
				<DetailsPage
					key="companies/add"
					module="companies"
					headerOptions={{ showAvatar: true, additionalInfo: CompaniesDetailsHeaderAdditionalInfo }}
					tabs={CompaniesDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'companies/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'companies'),
			element: (
				<DetailsPage
					key="companies/details"
					module="companies"
					headerOptions={{ showAvatar: true, additionalInfo: CompaniesDetailsHeaderAdditionalInfo }}
					tabs={CompaniesDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'companies/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'companies'),
			element: (
				<ViewPage
					key="companies/view"
					module="companies"
					content={{ type: 'tabs', tabs: CompaniesView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
